// extracted by mini-css-extract-plugin
export default {"title_container":"Title_title_container__0+Bqi","title":"Title_title__Sv0hz"};